/* ============================================================================
   BUNDLE BUILDER - "Build Your Set" behaviour
   Enhances the server-rendered sections/bundle-builder.liquid: add-to-set from
   the grid, a live summary (running total, tier state, struck pricing, per-item
   lines), colour swaps, tap-to-quick-view, and addAllToCart.

   Coordination note (the north star): each set line carries the offer identity
   as line-item properties - properties[_bundle]=<offer-id> and
   properties[_bundle_tier]=<pct>. That identity is what lets the offer be
   recognised + coordinated downstream (Regios reads it for the discount; the
   registry/blackout - step 4 - reads it to suppress colliding surfaces). This is
   the reference surface: an offer that declares itself, not a loose promo.

   Landmines honoured: FM-4 (no /cart/add form, no data-add-to-cart - adds go
   only through addAllToCart here) - FM-3 (atomic-422 handled, failing slot named).
   ============================================================================ */
(function () {
  'use strict';

  function money(cents) {
    try {
      if (window.theme && theme.Shopify && typeof theme.Shopify.formatMoney === 'function') {
        return theme.Shopify.formatMoney(cents, theme.money_format);
      }
    } catch (e) {}
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // Wooj colour palette - fallback when the variant colour metafield is empty.
  // Metafield hex (if a real hex) always wins; this maps the colour NAME.
  var NAMEMAP = {
    'matte black': '#2b2b2b', 'black': '#2b2b2b', 'eggshell': '#efe7d4', 'cream': '#efe7d4',
    'natural': '#e8ddc7', 'clear': '#e9e4d6', 'mustard': '#d8a12b', 'amber': '#d78b2e',
    'forest': '#33553f', 'emerald': '#2f6b4f', 'olive oil': '#8b8a4e', 'olive': '#8b8a4e',
    'smoke': '#6f6a66', 'vermillion': '#d94f27', 'cobalt': '#2f4f9e', 'periwinkle': '#8f9ff0',
    'mint': '#bfe3cf', 'seafoam': '#a7cbba', 'peach': '#f0b28f', 'lilac': '#c9b6e4',
    'pink lemonade': '#f2a9c0', 'pink': '#f2a9c0', 'sage': '#9aa88a', 'white': '#f4f1ea'
  };
  function resolveHex(hex, name) {
    if (hex && /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(String(hex).trim())) return String(hex).trim();
    return NAMEMAP[String(name || '').trim().toLowerCase()] || '#cccccc';
  }

  function init(root) {
    var dataEl = root.querySelector('[data-bundle-products]');
    if (!dataEl) return;
    var products;
    try { products = JSON.parse(dataEl.textContent); } catch (e) { return; }

    // PREVIEW-THEME sessions only: Shopify injects a max-z-index preview bar at
    // the bottom of the viewport that completely covers our fixed mobile summary
    // bar (Henya couldn't see the set / add-to-cart on mobile, 2026-08-11).
    // Lift the summary above it. The iframe injects late -> a few retries.
    (function liftAbovePreviewBar(tries) {
      var bar = document.getElementById('preview-bar-iframe');
      if (bar) {
        var h = Math.ceil(bar.getBoundingClientRect().height) || 0;
        var summary = root.querySelector('.bundle-builder__summary');
        if (h && summary) summary.style.bottom = h + 'px';
        return;
      }
      if (tries > 0) setTimeout(function () { liftAbovePreviewBar(tries - 1); }, 800);
    })(6);

    var byId = {};
    products.forEach(function (p) { byId[p.id] = p; });
    // variantId -> colour, built once (O(1) lookups instead of scanning per render)
    var colorByVariant = {};
    products.forEach(function (p) { (p.colors || []).forEach(function (c) { colorByVariant[c.id] = c; }); });

    // Tiers are SINGLE-SOURCED from the offer registry (offer_tier metaobjects):
    // the GENERIC builder offer = line_property on _bundle with NO exact value
    // (fixed preconfig bundles are value-matched and excluded here). N tiers
    // supported; marketing edits them in admin, zero theme changes.
    // the GENERIC set offer: collection_qty (unified any-lamp-counts model) or
    // the legacy no-value line_property. Preconfigs are value-matched, excluded.
    // Window-filtered like the resolver (sweep C1).
    function registryOffer() {
      var reg = (typeof window !== 'undefined' && window.OfferRegistry) || [];
      function winOk(o) {
        return !(window.OfferResolver && window.OfferResolver.inWindow) || window.OfferResolver.inWindow(o);
      }
      return reg.filter(function (o) {
        return o.enabled !== false && winOk(o) && o.trigger &&
               (o.trigger.type === 'collection_qty' ||
                (o.trigger.type === 'line_property' && o.trigger.key === '_bundle' && !o.trigger.value));
      })[0] || null;
    }
    function registryTiers() {
      var offer = registryOffer();
      return ((offer && offer.reward && offer.reward.tiers) || [])
        .filter(function (t) { return t.qty && t.pct; })
        .sort(function (a, b) { return a.qty - b.qty; });
    }
    var cfg = {
      offerId: root.dataset.offerId || 'build-your-set',
      tiers: registryTiers()
    };
    var MIN_QTY = cfg.tiers.length ? cfg.tiers[0].qty : 2;

    // ── the "editing your set" model (Sean, 2026-08-12) ──
    // Pieces ALREADY in the cart count toward the tier and render as locked
    // lines: a return visit EXTENDS the existing set instead of pretending to
    // start a new one (the drawer's "Add to your set" link lands here).
    // Preconfig-bundle lines never count (value-matched offers, own ladder).
    var inCart = { qty: 0, lines: [] };
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
      });
    }
    // Membership test WITHOUT OfferReward: this deferred script executes
    // (document order) BEFORE theme.liquid's offer-reward.js, so window.OfferReward
    // does not exist yet at init. Mirrors OfferReward.bundleQty(items, generic) —
    // the UNION (Sean's unified model, 2026-08-12): stamped non-preconfig lines OR
    // products in the offer's eligible collection. Gifts never count.
    function preconfigStampMap() {
      var pre = {};
      ((typeof window !== 'undefined' && window.OfferRegistry) || []).forEach(function (o) {
        var t = o.trigger || {};
        if (t.type === 'line_property' && t.key === '_bundle' && t.value != null) pre[String(t.value)] = 1;
      });
      return pre;
    }
    function eligibleIdMap() {
      var offer = registryOffer();
      var out = {};
      if (offer && offer.trigger && offer.trigger.type === 'collection_qty') {
        (offer.trigger.productIds || []).forEach(function (id) { out[String(id)] = 1; });
      }
      return out;
    }
    function isSetLine(i, pre, eligible) {
      var p = i.properties || {};
      if (p._offer_gift || p._gift_item === 'true') return false;
      var v = p._bundle;
      if (v && pre[String(v)]) return false;
      return !!v || !!eligible[String(i.product_id)];
    }
    function countBuilderLines(items) {
      var pre = preconfigStampMap();
      var eligible = eligibleIdMap();
      var n = 0;
      (items || []).forEach(function (i) {
        if (isSetLine(i, pre, eligible)) n += i.quantity || 1;
      });
      return n;
    }
    // ONE server-truth sync used by first paint, post-add, and drawer edits.
    var isSyncingCart = false;
    function syncFromServer() {
      if (typeof fetch !== 'function' || isSyncingCart) return;
      isSyncingCart = true;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('cart read failed'); return r.json(); })
        .then(function (cart) {
          var pre = preconfigStampMap();
          var eligible = eligibleIdMap();
          inCart.lines = (cart.items || []).filter(function (i) {
            return isSetLine(i, pre, eligible);
          }).map(function (i) {
            return { title: i.product_title, variant: i.variant_title, price: i.price, qty: i.quantity || 1, img: i.image };
          });
          inCart.qty = inCart.lines.reduce(function (s, l) { return s + l.qty; }, 0);
          isSyncingCart = false;
          render();
        })
        .catch(function () { isSyncingCart = false; });
    }
    function refreshInCart() {
      // COUNT synchronously from the server-rendered snapshot (accurate on first
      // paint, no request), then upgrade with titles/prices from ONE cart.js
      // read. The snapshot is rendered ONCE and never updated by mutations
      // (sweep #4: trusting it post-add zeroed the just-added set) - so any
      // later truth comes from syncFromServer, never the snapshot again.
      var snap = (window.__cartSnapshot && window.__cartSnapshot.items) || [];
      inCart.qty = countBuilderLines(snap);
      inCart.lines = [];
      render();
      if (inCart.qty) syncFromServer();
    }
    // Drawer edits (qty changes, remove set, gift moves) fire cart:refresh -
    // re-sync so the builder never argues with the cart (debounced).
    var cartSyncTimer = null;
    document.addEventListener('cart:refresh', function () {
      clearTimeout(cartSyncTimer);
      cartSyncTimer = setTimeout(syncFromServer, 400);
    });

    // Render the tier rail + hero tier line from the registry (the section no
    // longer server-renders tier values - they'd be a second copy of the truth).
    (function renderTierUI() {
      var rail = root.querySelector('[data-bundle-tiers]');
      if (rail) {
        rail.textContent = '';
        cfg.tiers.forEach(function (t) {
          var el = document.createElement('div');
          el.className = 'bundle-builder__tier';
          el.setAttribute('data-tier', String(t.qty));
          var count = document.createElement('div');
          count.className = 'bundle-builder__tier-count';
          count.textContent = t.qty + ' piece' + (t.qty === 1 ? '' : 's');
          var off = document.createElement('div');
          off.className = 'bundle-builder__tier-off';
          off.textContent = t.pct + '% off';
          el.appendChild(count); el.appendChild(off);
          rail.appendChild(el);
        });
      }
      var line = root.querySelector('[data-bundle-tierline]');
      if (line && cfg.tiers.length) {
        line.textContent = cfg.tiers.map(function (t, i) {
          return (i === 0 ? 'Add any ' + t.qty + ' pieces for ' : t.qty + ' for ') + t.pct + '%';
        }).join(' - ') + ' off.';
      }
    })();

    // state
    var chosen = [];                    // [{ productId, variantId }]
    var cardVariant = {};               // productId -> current variantId on the card
    products.forEach(function (p) { cardVariant[p.id] = (p.colors[0] || {}).id; });

    // ---- helpers -----------------------------------------------------------
    function colorOf(productId, variantId) {
      return colorByVariant[variantId] || (byId[productId] && byId[productId].colors[0]) || null;
    }
    function currentTier(n) {
      var t = null;
      cfg.tiers.forEach(function (tier) { if (n >= tier.qty) t = tier; });
      return t;
    }
    function nextTier(n) {
      for (var i = 0; i < cfg.tiers.length; i++) if (n < cfg.tiers[i].qty) return cfg.tiers[i];
      return null;
    }
    function countInSet(productId) {
      return chosen.filter(function (c) { return c.productId === productId; }).length;
    }

    // ---- grid wiring -------------------------------------------------------
    function wireCards() {
      root.querySelectorAll('.bundle-builder__card').forEach(function (card) {
        var pid = parseInt(card.dataset.productId, 10);

        // colour dots - swap the card's selected variant, image, price
        card.querySelectorAll('.bundle-builder__dot').forEach(function (dot) {
          dot.addEventListener('click', function () {
            var vid = parseInt(dot.dataset.variantId, 10);
            cardVariant[pid] = vid;
            var c = colorOf(pid, vid);
            if (c) {
              var img = card.querySelector('[data-bundle-img]');
              if (img && c.img) img.src = c.img;
              var price = card.querySelector('[data-bundle-price]');
              if (price && countInSet(pid) === 0) price.textContent = money(c.price);
            }
            card.querySelectorAll('.bundle-builder__dot').forEach(function (d) { d.classList.remove('is-selected'); });
            dot.classList.add('is-selected');
          });
        });

        // add button - push to set (no /cart/add here - FM-4)
        var addBtn = card.querySelector('[data-bundle-add]');
        if (addBtn) {
          addBtn.addEventListener('click', function () {
            chosen.push({ productId: pid, variantId: cardVariant[pid] });
            render();
          });
        }

        // tap image or name - quick view
        card.querySelectorAll('[data-bundle-quickview]').forEach(function (el) {
          var open = function (e) { e.preventDefault(); openQuickView(pid); };
          el.addEventListener('click', open);
          if (el.getAttribute('role') === 'button') {
            el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') open(e); });
          }
        });
      });
    }

    function paintCards() {
      root.querySelectorAll('.bundle-builder__card').forEach(function (card) {
        var pid = parseInt(card.dataset.productId, 10);
        var qty = countInSet(pid);
        var inSet = qty > 0;
        card.classList.toggle('is-in-set', inSet);
        var flag = card.querySelector('.bundle-builder__flag');
        if (flag) flag.textContent = 'In set' + (qty > 1 ? ' x' + qty : '');
        var addBtn = card.querySelector('[data-bundle-add]');
        if (addBtn) {
          addBtn.classList.toggle('is-added', inSet);
          addBtn.textContent = inSet ? ('Add another' + (qty > 1 ? ' (x' + qty + ')' : '')) : 'Add to Set';
        }
      });
    }

    // ---- summary -----------------------------------------------------------
    function render() { paintCards(); renderSummary(); }

    function renderSummary() {
      var n = chosen.length;                 // NEW picks this visit
      var nTotal = n + inCart.qty;           // the whole set (cart + new) drives the tier
      var chosenTotal = chosen.reduce(function (sum, item) {
        var c = colorOf(item.productId, item.variantId);
        return sum + (c ? c.price : 0);
      }, 0);
      var inCartTotal = inCart.lines.reduce(function (s, l) { return s + l.price * l.qty; }, 0);
      var regular = chosenTotal + inCartTotal;
      var tier = currentTier(nTotal);
      var pct = tier ? tier.pct : 0;
      var qualified = !!tier && nTotal > 0;
      var savings = qualified ? Math.round(regular * pct / 100) : 0;
      var total = regular - savings;

      // the "already in your cart" chip (hidden on a fresh visit)
      var chip = root.querySelector('[data-bundle-incart]');
      if (chip) {
        chip.style.display = inCart.qty ? '' : 'none';
        chip.textContent = inCart.qty + ' set piece' + (inCart.qty === 1 ? '' : 's') + ' already in your cart';
      }

      // tier rail active state
      root.querySelectorAll('.bundle-builder__tier').forEach(function (el) {
        el.classList.toggle('is-active', qualified && parseInt(el.dataset.tier, 10) === tier.qty);
      });

      // chosen list — locked in-cart lines first (no remove here; edit in the
      // cart), then this visit's picks
      var list = root.querySelector('[data-bundle-chosen]');
      if (list) {
        var lockedHtml = inCart.lines.map(function (l) {
          var lp = qualified
            ? '<span class="bundle-builder__ci-was">' + money(l.price) + '</span>' + money(Math.round(l.price * (100 - pct) / 100))
            : money(l.price);
          return '<li class="bundle-builder__ci bundle-builder__ci--incart">' +
            (l.img ? '<img src="' + esc(l.img) + '" alt="" width="44" height="44">' : '') +
            '<span class="bundle-builder__ci-meta">' +
              '<span class="bundle-builder__ci-name">' + esc(l.title) + (l.qty > 1 ? ' x' + l.qty : '') + '</span>' +
              (l.variant && l.variant !== 'Default Title' ? '<span class="bundle-builder__ci-color">' + esc(l.variant) + '</span>' : '') +
              '<span class="bundle-builder__ci-price">' + lp + '</span>' +
            '</span>' +
            '<span class="bundle-builder__ci-tag">In cart</span>' +
          '</li>';
        }).join('');
        list.innerHTML = lockedHtml + chosen.map(function (item, idx) {
          var p = byId[item.productId];
          var c = colorOf(item.productId, item.variantId);
          var line = qualified
            ? '<span class="bundle-builder__ci-was">' + money(c.price) + '</span>' + money(Math.round(c.price * (100 - pct) / 100))
            : money(c.price);
          return '<li class="bundle-builder__ci">' +
            '<img src="' + (c.img || '') + '" alt="" width="44" height="44">' +
            '<span class="bundle-builder__ci-meta">' +
              '<span class="bundle-builder__ci-name">' + p.title + '</span>' +
              '<span class="bundle-builder__ci-color">' + c.name + '</span>' +
              '<span class="bundle-builder__ci-price">' + line + '</span>' +
            '</span>' +
            '<button type="button" class="bundle-builder__ci-remove" data-remove="' + idx + '" aria-label="Remove">x</button>' +
          '</li>';
        }).join('');
        list.querySelectorAll('[data-remove]').forEach(function (b) {
          b.addEventListener('click', function () { chosen.splice(parseInt(b.dataset.remove, 10), 1); render(); });
        });
      }

      // savings line + struck total
      var savingsEl = root.querySelector('[data-bundle-savings]');
      var savingsVal = root.querySelector('[data-bundle-savings-val]');
      var was = root.querySelector('[data-bundle-was]');
      var now = root.querySelector('[data-bundle-now]');
      if (qualified) {
        if (savingsEl) savingsEl.hidden = false;
        if (savingsVal) savingsVal.textContent = '-' + money(savings) + ' (' + pct + '%)';
        if (was) { was.hidden = false; was.textContent = money(regular); }
      } else {
        if (savingsEl) savingsEl.hidden = true;
        if (was) was.hidden = true;
      }
      if (now) now.textContent = money(total);

      // mobile peek-bar mirror (the WHOLE set, cart + new)
      var peekSub = root.querySelector('[data-bundle-peek-sub]');
      var peekTotal = root.querySelector('[data-bundle-peek-total]');
      if (peekSub) peekSub.textContent = nTotal + (nTotal === 1 ? ' piece' : ' pieces');
      if (peekTotal) peekTotal.textContent = money(total);

      // status — tier truth from the COMBINED count (a return visit with 2 in
      // cart must never read "add 2 to unlock 15%"; Sean 2026-08-12)
      var status = root.querySelector('[data-bundle-status]');
      if (status) {
        if (!cfg.tiers.length) {
          // No tier ladder in the registry (missing/expired/misconfigured offer):
          // the builder still WORKS as a picker, it just promises no discount.
          // Reading cfg.tiers[0].pct here crashed the whole page (sweep H2).
          status.textContent = nTotal === 0
            ? 'Pick your pieces to build a set.'
            : nTotal + (nTotal === 1 ? ' piece' : ' pieces') + ' in your set.';
        } else if (nTotal === 0) {
          status.innerHTML = 'Pick any <b>' + MIN_QTY + '</b> pieces to unlock <b>' + cfg.tiers[0].pct + '% off</b>.';
        } else if (!qualified) {
          var need = MIN_QTY - nTotal;
          status.innerHTML = nTotal + ' of ' + MIN_QTY + ' - add <b>' + need + '</b> more for <b>' + cfg.tiers[0].pct + '% off</b>.';
        } else {
          var nt = nextTier(nTotal);
          var lead = inCart.qty && n === 0
            ? 'Your set is at <b>' + pct + '% off</b>.'
            : 'Nice - <b>' + pct + '% off</b> unlocked.';
          status.innerHTML = nt
            ? lead + ' Add <b>' + (nt.qty - nTotal) + '</b> more for <b>' + nt.pct + '% off</b>.'
            : 'Top tier - <b>' + pct + '% off</b> your set.';
        }
      }

      // CTA — enabled only with NEW picks; copy speaks to extending when the
      // cart already holds set pieces
      var cta = root.querySelector('[data-bundle-cta]');
      if (cta) {
        if (n === 0) {
          cta.disabled = true;
          cta.textContent = inCart.qty ? 'Pick pieces to add to your set' : 'Add products to start';
        } else {
          cta.disabled = false;
          if (inCart.qty) {
            cta.innerHTML = qualified
              ? 'Add ' + n + (n === 1 ? ' piece' : ' pieces') + ' - set becomes ' + pct + '% off'
              : 'Add ' + n + (n === 1 ? ' piece' : ' pieces') + ' to your set';
          } else {
            cta.innerHTML = qualified
              ? 'Add set to cart - ' + money(total) + ' <s>' + money(regular) + '</s>'
              : 'Add ' + n + (n === 1 ? ' piece' : ' pieces') + ' to cart - ' + money(total);
          }
        }
      }
    }

    // ---- quick view --------------------------------------------------------
    var qv = null, qvProductId = null;
    function buildQuickView() {
      if (qv) return qv;
      qv = document.createElement('div');
      qv.className = 'bundle-qv';
      qv.setAttribute('aria-hidden', 'true');
      qv.innerHTML =
        '<div class="bundle-qv__panel" role="dialog" aria-modal="true">' +
          '<button type="button" class="bundle-qv__close" aria-label="Close">x</button>' +
          '<div class="bundle-qv__media"><img data-qv-img src="" alt=""></div>' +
          '<div class="bundle-qv__body">' +
            '<p class="bundle-qv__eyebrow" data-qv-eyebrow></p>' +
            '<h3 class="bundle-qv__title" data-qv-title></h3>' +
            '<div class="bundle-qv__price" data-qv-price></div>' +
            '<p class="bundle-qv__desc" data-qv-desc></p>' +
            '<button type="button" class="bundle-qv__more" data-qv-more hidden>Show more</button>' +
            '<div class="bundle-builder__colors" data-qv-colors></div>' +
            '<button type="button" class="bundle-builder__add bundle-qv__add" data-qv-add>Add to Set</button>' +
          '</div>' +
        '</div>';
      document.body.appendChild(qv);
      qv.querySelector('.bundle-qv__close').addEventListener('click', closeQuickView);
      qv.addEventListener('click', function (e) { if (e.target === qv) closeQuickView(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQuickView(); });
      qv.querySelector('[data-qv-more]').addEventListener('click', function () {
        var d = qv.querySelector('[data-qv-desc]');
        var clamped = d.classList.toggle('is-clamped');
        this.textContent = clamped ? 'Show more' : 'Show less';
      });
      qv.querySelector('[data-qv-add]').addEventListener('click', function () {
        if (qvProductId == null) return;
        chosen.push({ productId: qvProductId, variantId: cardVariant[qvProductId] });
        render();
        closeQuickView();
      });
      return qv;
    }
    function openQuickView(pid) {
      qvProductId = pid;
      var p = byId[pid];
      var c = colorOf(pid, cardVariant[pid]);
      buildQuickView();
      qv.querySelector('[data-qv-eyebrow]').textContent = 'Wooj';
      qv.querySelector('[data-qv-title]').textContent = p.title;
      qv.querySelector('[data-qv-img]').src = c ? c.img : '';
      qv.querySelector('[data-qv-price]').textContent = c ? money(c.price) : '';
      var desc = qv.querySelector('[data-qv-desc]');
      desc.textContent = p.description || '';
      desc.classList.add('is-clamped');
      var more = qv.querySelector('[data-qv-more]');
      more.textContent = 'Show more';
      // colours in the modal
      qv.querySelector('[data-qv-colors]').innerHTML = p.colors.map(function (col) {
        var sel = col.id === cardVariant[pid] ? ' is-selected' : '';
        // the site's uploaded swatch file, hex beneath as the 404 fallback (matches the cards)
        var img = col.swatch ? " --dot-img: url('" + String(col.swatch).replace(/['"<>]/g, '') + "');" : '';
        return '<button type="button" class="bundle-builder__dot' + sel + '" data-qv-color="' + col.id + '" ' +
          'style="--dot-color: ' + resolveHex(col.hex, col.name) + ';' + img + '" aria-label="' + col.name + '"><span class="bundle-builder__dot-fill"></span></button>';
      }).join('');
      qv.querySelectorAll('[data-qv-color]').forEach(function (d) {
        d.addEventListener('click', function () {
          // update the modal in place - do NOT re-open (that rebuilt the whole
          // modal + re-bound listeners + re-ran the show-more measure each click).
          cardVariant[pid] = parseInt(d.dataset.qvColor, 10);
          var nc = colorOf(pid, cardVariant[pid]);
          if (nc) {
            qv.querySelector('[data-qv-img]').src = nc.img;
            qv.querySelector('[data-qv-price]').textContent = money(nc.price);
          }
          qv.querySelectorAll('[data-qv-color]').forEach(function (b) {
            b.classList.toggle('is-selected', parseInt(b.dataset.qvColor, 10) === cardVariant[pid]);
          });
          syncCardColor(pid);
        });
      });
      qv.setAttribute('aria-hidden', 'false');
      qv.classList.add('is-open');
      // decide show-more after layout
      requestAnimationFrame(function () { more.hidden = desc.scrollHeight <= desc.clientHeight + 2; });
    }
    function closeQuickView() { if (qv) { qv.classList.remove('is-open'); qv.setAttribute('aria-hidden', 'true'); } qvProductId = null; }
    function syncCardColor(pid) {
      var card = root.querySelector('.bundle-builder__card[data-product-id="' + pid + '"]');
      if (!card) return;
      var c = colorOf(pid, cardVariant[pid]);
      var img = card.querySelector('[data-bundle-img]'); if (img && c) img.src = c.img;
      card.querySelectorAll('.bundle-builder__dot').forEach(function (d) {
        d.classList.toggle('is-selected', parseInt(d.dataset.variantId, 10) === cardVariant[pid]);
      });
      var price = card.querySelector('[data-bundle-price]'); if (price && c && countInSet(pid) === 0) price.textContent = money(c.price);
    }

    // ---- add to cart -------------------------------------------------------
    function addAllToCart() {
      if (!chosen.length) return;
      // tier from the WHOLE set (in-cart + new) — extending 2 with 1 stamps 20
      var tier = currentTier(chosen.length + inCart.qty);
      var pct = tier ? tier.pct : 0;

      // group identical variants - one line with quantity; stamp offer identity
      var lines = {};
      chosen.forEach(function (item) {
        lines[item.variantId] = (lines[item.variantId] || 0) + 1;
      });
      var items = Object.keys(lines).map(function (vid) {
        return {
          id: parseInt(vid, 10),
          quantity: lines[vid],
          properties: { _bundle: cfg.offerId, _bundle_tier: String(pct) }
        };
      });

      var cta = root.querySelector('[data-bundle-cta]');
      if (cta) cta.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        if (res.ok) return res.json();
        // FM-3: atomic-fail - surface which line failed, re-enable
        return res.json().then(function (err) { throw err; });
      }).then(function (result) {
        document.dispatchEvent(new CustomEvent('cart:add', { detail: result }));
        if (window.cartDrawer && typeof window.cartDrawer.open === 'function') window.cartDrawer.open();
        else if (window.cartDrawer && typeof window.cartDrawer.refresh === 'function') window.cartDrawer.refresh();
        // The set is now in the cart: merge the added pieces into the in-cart
        // state LOCALLY for instant truth (the snapshot is stale the moment we
        // mutate - sweep #4), clear the picks, then confirm against the server.
        chosen.forEach(function (item) {
          var p = byId[item.productId];
          var c = colorOf(item.productId, item.variantId);
          inCart.lines.push({ title: p ? p.title : '', variant: c ? c.name : '', price: c ? c.price : 0, qty: 1, img: c ? c.img : '' });
        });
        inCart.qty += chosen.length;
        chosen = [];
        render();
        syncFromServer();
      }).catch(function (err) {
        if (cta) cta.disabled = false;
        var msg = (err && (err.description || err.message)) || 'Something went wrong - please try again.';
        var status = root.querySelector('[data-bundle-status]');
        if (status) status.innerHTML = '<b>' + msg + '</b>';
      });
    }

    // fix server-rendered dot colours (metafield may be empty -> map by name)
    function paintDotColors() {
      root.querySelectorAll('.bundle-builder__dot[data-color-name]').forEach(function (d) {
        d.style.setProperty('--dot-color', resolveHex(d.dataset.hex, d.dataset.colorName));
      });
    }

    // ---- init --------------------------------------------------------------
    wireCards();
    paintDotColors();
    // make each card's load image/price match its first selected colour
    products.forEach(function (p) { syncCardColor(p.id); });
    var cta = root.querySelector('[data-bundle-cta]');
    if (cta) cta.addEventListener('click', function () { if (!this.disabled) addAllToCart(); });
    // mobile: tap the peek handle to expand/collapse the set summary
    var peek = root.querySelector('[data-bundle-peek]');
    var summaryEl = root.querySelector('.bundle-builder__summary');
    if (peek && summaryEl) peek.addEventListener('click', function () { summaryEl.classList.toggle('is-collapsed'); });
    refreshInCart(); // renders immediately (snapshot count), upgrades with cart.js lines
  }

  function boot() { document.querySelectorAll('.cc-bundle-builder').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
